import React from 'react';
import Header from '../components/Header';
import { Link } from 'react-router-dom';
import CustomPageTiles from '../components/CustomPageTiles';

function SlovakMisc() {
  return <>
    <Header />

    <div id="tiles">
        <Link id="match-words" className='link' to="/slovak/words">
            <span>Slová</span>
        </Link>
        <Link id="match-chosen" className='link' to="/slovak/chosen">
            <span>Vybrané slová</span>
        </Link>
        <CustomPageTiles path="/slovak" />
    </div>
  </>
}

export default SlovakMisc;
